import script from "./ButtonUp.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonUp.vue?vue&type=script&setup=true&lang=js"

import "./ButtonUp.vue?vue&type=style&index=0&id=72e3241b&lang=scss"

const __exports__ = script;

export default __exports__